import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {}
});

export function groupsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_GROUPS_COLLECTION_SUCCESS:
      return state.merge({
        params: action.payload.params || {},
        byId: action.payload.byId || {}
      })
    default:
      return state
  }
}